import { Translation, TranslationsResponse } from 'interfaces/app';
import ApiService from 'services/ApiService';
import { httpClient } from 'utils/http';

class TranslationService extends ApiService<Translation> {
        constructor() {
                super('translation');
        }

        async getMultiTranslation(parameter: URLSearchParams): Promise<TranslationsResponse> {
                const response = await httpClient.get(`${this.ENDPOINT}/multi?${parameter}`);
                return response.data;
        }

        async getOptionValueTranslation(valueId: number | string, languageId: number | string): Promise<{ translation: string } | null> {
                try {
                        const params = new URLSearchParams({
                                ns: 'offeringoptionvalues',
                                lng: String(languageId),
                                limit: '0',
                        });
                        const data = await this.getMultiTranslation(params);
                        const langData = data[String(languageId)] as any;
                        const translations = langData?.offeringoptionvalues || {};
                        return { translation: translations[String(valueId)] || '' };
                } catch (error) {
                        console.error('Failed to get option value translation:', error);
                        return null;
                }
        }

        async saveOptionValueTranslation(valueId: number | string, languageId: number | string, translation: string): Promise<void> {
                await httpClient.put(this.ENDPOINT, {
                        namespace: 'offeringoptionvalues',
                        language: languageId,
                        bundle: { [valueId]: translation },
                });
        }
}

export default new TranslationService();
